import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = [
  {
    q: "Where do you deliver weed in Washington, DC?",
    a: "Farmacy District DC offers fast and reliable delivery throughout Washington, DC — all major neighborhoods, residential areas, hotels, and short-term stays within the District. Note: we only deliver within Washington, DC in compliance with local cannabis laws. Whether you're ordering for yourself or sending a cannabis gift, our team ensures discreet, hassle-free delivery every time.",
  },
  {
    q: "Can you order weed in Washington, DC?",
    a: "Yes. To order from Farmacy District DC you must be 21 years or older. All customers verify their age during checkout and provide valid identification upon request. This process ensures full compliance with Washington, DC cannabis regulations.",
  },
  {
    q: "Do you offer special weed deals?",
    a: "Yes! We regularly offer exclusive cannabis deals and promotions so you can enjoy premium products at affordable prices — discounted flowers, edible specials, limited-time offers and new product promos. First-time customers get 10% off with code FirstPurchase.",
  },
  {
    q: "Do I need to register to order?",
    a: "Account registration is required to place an online order — it's quick and easy: create an account, verify your age, browse the menu and place your order. Returning customers can log in anytime to reorder their favorite products.",
  },
  {
    q: "Are THC gummies legal in Washington, DC?",
    a: "Yes. THC edibles, including gummies, are legal in Washington, DC under Initiative 71 when possessed and consumed in accordance with local law. You must be 21+, products are formulated to meet DC compliance standards, and consumption must follow DC guidelines. Farmacy District DC follows all applicable cannabis regulations.",
  },
  {
    q: "How do I order edibles in Washington, DC?",
    a: "It's simple: browse our online edibles menu, select your products, upload a valid photo ID for age verification, complete checkout on our secure platform, and receive your delivery within 30–90 minutes.",
  },
  {
    q: "Who do you deliver to?",
    a: "We proudly serve local DC residents, visitors and travelers, customers staying at hotels, Airbnbs and short-term rentals, and first-time and returning shoppers.",
  },
  {
    q: "Which neighborhoods do you serve?",
    a: "We deliver across all major DC neighborhoods, including Wharf, Shaw, NoMa, Navy Yard, Georgetown, Adams Morgan, Foggy Bottom, U Street Corridor, Northwest DC, and areas near the National Mall and Downtown DC.",
  },
];

export default function Faq() {
  return (
    <main data-testid="faq-page">
      <Seo
        title="FAQs | Cannabis Delivery Questions | Farmacy District DC"
        description="Answers about cannabis delivery in Washington, DC — delivery areas, age requirements, legality under Initiative 71, ordering, deals and more."
      />
      <section className="bg-brand-ink py-20 text-white grain sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-lime">Good to Know</p>
            <h1 className="mt-4 font-display text-4xl font-black tracking-tighter sm:text-6xl">FAQs on Weed Delivery in Washington DC</h1>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-base font-bold tracking-tight sm:text-lg">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-neutral-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-14 border border-neutral-200 bg-brand-sand p-8 text-center" id="laws">
          <h2 className="font-display text-xl font-bold tracking-tight">DC Cannabis Laws</h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-neutral-600">
            PICK UP AND DELIVERY ONLY · Initiative 71 Compliant Gifting · For use only by adults 21 years of age and
            older · Keep out of reach of children.
          </p>
          <Link to="/shop" className="mt-6 inline-block rounded-full bg-brand-ink px-8 py-3 text-sm font-bold text-white transition-colors hover:bg-neutral-800" data-testid="faq-shop-cta">
            SHOP THE MENU
          </Link>
        </div>
        <div id="privacy" className="mt-8 text-center text-xs text-neutral-400">
          <p>Privacy Policy & Terms of Service: your information is used only to fulfill orders and is never sold. By ordering you agree to our terms and confirm you are 21+.</p>
        </div>
        <div id="terms" />
      </section>
    </main>
  );
}
